// extracted by mini-css-extract-plugin
export default {"tabContent":"TabPanel_tabContent__XXK9k","invisible":"TabPanel_invisible__U1Q-J"};